module.exports = "/_next/static/images/8b392426f2e219a5185a5c7572f22733-nuapp@1x.png.webp";